/*
 *   File : add-bank.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - Add Bank page
 *   Integrations : react-toastify
 *   Version : 1.0.0
 *   Date : 14-10-2025
 */

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";
import { useNavigate } from "react-router-dom";

// *********** Components ***************//
import { Icon } from "../../../Component/Icon";
import { PrimaryButton, TextButton } from "../../../Component/Buttons";
import { _getSignupProgress, _trackEvent } from "../../../Helper";
import { APIService } from "../../../Service";
import { EmptyScreen } from "../../../Component/Other";
import { WhyMandatoryInvestModal, OnboardingInvestModal } from "../../../Component/Modal";
import OnboardingVideoModal from "../../../Component/Modal/onboardingVideoModal";
import { Pagination } from "../../../Component/Pagination";
import { CustomTextInput } from "../../../Component/Form-Elements";
import { FundCard } from "../../../Component/Cards";

// *********** Assets ***************//
import Loader from "../../../Assets/Images/loader.gif";
import NextIcon from "../../../Assets/Images/right-black-icon.svg";
import EmptyFunds from "../../../Assets/Images/EmptyScreen/no-data.webp";

// *********** Styles ***************//
import styles from "../../../Style/Component/login.module.scss";



const ACCORDION_ITEMS_1 = [
	{
		id: "invest-faq-1",
		title: "What is the min amount I need to invest?",
		description: `The minimum investment required to start in an index fund is highly accessible, generally ranging from ₹100 to ₹500 for a monthly SIP or ₹1,000 for a Lumpsum investment, depending on the specific fund house and scheme.`,
	},
	{
		id: "invest-faq-2",
		title: "How do I ensure my money is safe?",
		description: `The minimum investment required to start in an index fund is highly accessible, generally ranging from ₹100 to ₹500 for a monthly SIP or ₹1,000 for a Lumpsum investment, depending on the specific fund house and scheme.`,
	},
	{
		id: "invest-faq-3",
		title: "What is the min amount I need to invest?",
		description: `The minimum investment required to start in an index fund is highly accessible, generally ranging from ₹100 to ₹500 for a monthly SIP or ₹1,000 for a Lumpsum investment, depending on the specific fund house and scheme.`,
	},
	{
		id: "invest-faq-4",
		title: "How do I ensure my money is safe?",
		description: `The minimum investment required to start in an index fund is highly accessible, generally ranging from ₹100 to ₹500 for a monthly SIP or ₹1,000 for a Lumpsum investment, depending on the specific fund house and scheme.`,
	},
];

const ITEMS_PER_PAGE = 6;

const CATEGORIES = [
	{
		id: "GOLD/SILVER",
		name: "Gold/Silver",
	},
	{
		id: "DEBT",
		name: "Debt",
	},
	{
		id: "EQUITY",
		name: "Equity",
	},
	{
		id: "EXPLORE",
		name: "Explore",
	},
];

const FUND_DATA = {
	"mf_id": 370,
	"name": "SBI CRISIL IBX Gilt Index - April 2029 Fund - Regular Plan - Growth",
	"image": "https://zappa-9dc5cpgcl.s3.ap-south-1.amazonaws.com/public/amc-images/sbi_groww.png",
	"scheme_category": "Other",
	"sip_dates": "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28",
	"nav": 10,
	"option_name": "Growth",
	"payment_types": [
		{
			"id": 2,
			"label": "UPI",
			"slug": "UPI"
		},
		{
			"id": 1,
			"label": "Net Banking",
			"slug": "NETBANKING"
		}
	],
	"mandate_status": false,
	"lumpsum": null,
	"sip": null,
	"min_investment": {
		"lumpsum": 5000,
		"sip": 500
	}
};

function BasketList(props) {
	//get general data from redux
	const navigate = useNavigate();

	const [currentStep, setCurrentStep] = useState(1);
	const [fundList, setFundList] = useState([]);
	const [selectedFundType, setSelectedFundType] = useState({ id: "GOLD/SILVER", name: "Gold/Silver" });
	const [categories, setCategories] = useState(CATEGORIES);
	const [fundSummary, setFundSummary] = useState(FUND_DATA);
	const [fundData, setFundData] = useState(null);
	const [searchValue, setSearchValue] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPageCount, setTotalPageCount] = useState(10);
	const [showInvestModal, setShowInvestModal] = useState(false);
	const [showWhyInvestModal, setShowWhyInvestModal] = useState(false);
	const [showPagination, setShowPagination] = useState(false);
	const [loading, setLoading] = useState(true);
	const [sliderVideos, setSliderVideos] = useState([]);
	const [currentVideo, setCurrentVideo] = useState(null);

	useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }) }, [currentStep, currentPage]);

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === 'Enter') {
				// Call _listFunds function when Enter is pressed
				if (currentStep === 3) {
					_listFunds();
				}
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [currentStep, searchValue]);


	useEffect(() => {
		if (currentVideo !== null) {

		}
	}, [currentVideo]);
	useEffect(() => {

		function _getVideos() {
			let url = 'videos/get';
			APIService(false, url, null, null, 2).then((response) => {
				if (response.status_code === 200) {
					setSliderVideos(response.data);
				}
			})
		}

		_getVideos();
	}, []);

	useEffect(() => {
		// API call to get categories
		if (currentStep > 1) {
			_listFunds();
		}
	}, [currentStep, currentPage, selectedFundType]);


	useEffect(() => {
		// _getCategories();
	}, [])

	useEffect(() => {
		if (showInvestModal == true) {
			const invest_modal = new Modal(
				document.getElementById("invest-mf-modal")
			);
			invest_modal.show();
		}
	}, [showInvestModal]);

	useEffect(() => {
		if (currentVideo !== null) {
			new Modal(document.querySelector("#onboarding-video")).show();
		}
	}, [currentVideo]);

	useEffect(() => {
		if (showWhyInvestModal == true) {
			new Modal(document.querySelector("#why-mandatory-invest")).show();
		}
	}, [showWhyInvestModal]);

	const _handleSelectFundType = (selected_type) => {
		setFundList([]);
		setCurrentPage(1);
		setSelectedFundType(selected_type);
	};

	// handle paginating
	const _handlePagination = (new_start_limit) => {
		const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
		setCurrentPage(selected_page);
	};

	// handle modal close
	const _handleCloseInvestModal = (type) => {
		// Closing modal
		var button = document.getElementById("mf-invest-modal-close");
		button.click();

		if (type) {
			_getSignupProgress();
			navigate(`/thank-you?type=${type}`, { replace: true });
		}
		setShowInvestModal(false);
		setLoading(false);
	};


	const _handleSearchChange = (value) => {
		setSearchValue(value);
		if (!value) {
			setCurrentPage(1);
			setFundList([]);
			let current_page = 1;
			let search_value = "";
			_listFunds(current_page, search_value);
		}
	};

	const _handleSearchFund = () => {
		setFundList([]);
		setCurrentPage(1);
		_listFunds(1);
	};

	const _handleShowInvestModal = (fund_data) => {
		let api_version = 2;
		let is_post = true;
		let url = "mf/summary";
		let data = {
			mf_id: fund_data.mf_id,
			type: null,
		};
		let token = sessionStorage.getItem("access_token");

		APIService(is_post, url, data, token, api_version).then((response) => {
			if (response.status_code === 200) {
				setFundSummary(response.data);
				setFundData(fund_data);
				setShowInvestModal(true);
				_trackEvent("fund_selected", { screen: "investment_activation", fund_id: fund_data.mf_id });
				_trackEvent("screen_investment_activation_viewed", { screen: "investment_activation" });
			} else {
				setFundSummary(null);
				toast.error(response.message);
			}
		});
	};

	const _handleNavigateFundListing = () => {
		setCurrentStep(2);
	};

	const _handleNavigateExplore = () => {
		_trackEvent("explore_more_funds_clicked", { screen: "investment_activation" });
		setCurrentStep(3); // 3 - Explore page
		setCurrentPage(1); // Re setting to first page
		setFundList([]);
	};

	const _handleShowWhyMandatoryInvestModal = () => {
		setShowWhyInvestModal(true);
	};

	const _handleCloseWhyMandatoryInvestModal = () => {
		setShowWhyInvestModal(false);
	};

	const _handleBack = () => {
		setCurrentPage(1);
		setFundList([]);
		setSearchValue("");
		setCurrentStep(currentStep - 1);
	}


	//API- Post Filter
	const _getCategories = () => {
		let api_version = 2;
		let is_post = false;
		let url = "scheme/suggested-categories";
		let data = null;
		let token = sessionStorage.getItem("access_token");

		APIService(is_post, url, data, token, api_version).then((response) => {
			if (response.status_code === 200) {
				setCategories(response.data);
				setSelectedFundType(response?.data[0])
			} else {
				setCategories([]);
			}
			setLoading(false);
		});
	};

	//API- Post Filter
	const _listFunds = (page = currentPage, search = searchValue) => {
		setLoading(true);
		let api_version = 2;
		let is_post = true;
		let url = "scheme/list";
		let data = {
			page_num: page,
			page_size: 10,
			scheme_name: search,
			fund_category: currentStep !== 3 ? selectedFundType?.id : null,
			sort: 3,
			onboarding: true,
			// "fund_category": null
		};
		let token = sessionStorage.getItem("access_token");

		APIService(is_post, url, data, token, api_version,).then((response) => {
			if (response.status_code === 200) {
				setFundList(response.data.funds);
				setTotalPageCount(Math.floor(response.data.total_items / ITEMS_PER_PAGE));
				if (response.data.total_items > 10 && response.data.funds.length >= 10) {
					setShowPagination(true);
				}
			} else {
				setFundList([]);
				setShowPagination(false);
			}
			setLoading(false);
		});
	};

	const _openVideoModal = (data) => {
		setCurrentVideo(data);
	}


	const VideoCard = ({ key, data }) => {
		return (
			<div className="d-flex flex-column e-border-1px-lavender e-border-radius-16 overflow-hidden cursor-pointer h-100" key={key}
				onClick={() => _openVideoModal(data.video_id)}>
				<div className="video-wrapper position-relative">
					<img
						src={data.thumbnail}
						className="e-onboarding-slider-thumb"
						alt="video thumnail"
						draggable="false"
					/>
					<span className="video-ply-btn">
						<Icon icon="video-play-btn" className="w-32px w-24px-lg-res" />
						<span className="e-text-dark-jet e-font-12-lg-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-14px">
							{data.duration}
						</span>
					</span>
				</div>

				<div className="padding-12px-all">
					<h5 className="e-text-dark-jet e-font-12-res e-font-16 e-alt-font-poppins e-font-weight-500 line-height-20px margin-12px-bottom">
						{data.title}
					</h5>
					<p className="e-text-dark-jet e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-500 line-height-14px margin-2px-bottom">
						{data.speaker_name}
					</p>
					<p className="e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-14px mb-0">
						{data.designation}
					</p>
				</div>
			</div>
		);
	};

	return (
		<div className="col-sm-10 col-md-11 col-xl-10 mx-auto px-md-5">
			<div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
				<div className={`${styles.e_onboarding_wrapper_invest_details} e-border-radius-24 min-vh-100 overflow-scroll no-scrollbar`}>
					{
						currentStep === 1 ? (
							<div className="vh-100 position-relative padding-32px-top padding-0px-top-res">
								<section className="text-center mb-4 pb-3 px-sm-4">
									<p className="e-text-dark-jet e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px mb-2">
										Welcome to a smarter way to invest
									</p>
									<h1 className="e-text-chinese-black e-font-18-res e-font-24 e-alt-font-poppins e-font-weight-600 line-height-30px mb-0">
										Your profile is now set. Based on your goals and risk comfort, we’ll guide you with
										<span className="e-text-egyptian-blue"> personalised investment choices. </span>
									</h1>
								</section>

								<section>
									<div className="d-flex flex-column flex-md-row row-gap-4  align-items-center flex-wrap">
										<div className="col-sm-7 col-md-4 col-lg-4">
											<img
												src={require("../../../Assets/Images/Onboarding/invest/asst-under-mgt.png")}
												className="col-12 col-lg-10"
												// width={300}
												alt="Asset under management image"
												draggable="false"
											/>
										</div>
										<div className="col-sm-11 col-md-8 col-lg-8 flex-fill padding-56px-right padding-right-24px-lg padding-right-0px-md">
											<h6 className="text-center text-md-start e-text-dark-jet e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-500 line-height-20px mb-2">
												OUR PROMISE
											</h6>
											<div className="e-border-1px-bright-gray-2 d-flex flex-row flex-sm-row justify-content-between p-3 px-sm-4 padding-10px-tb align-items-center e-border-radius-16 mb-3">
												<span className="text-center text-md-start padding-12px-tb px-2 px-sm-auto d-flex flex-column flex-md-row align-items-center gap-12px e-text-black e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-16px ">
													<Icon icon="exper-backed" size={"1.5rem"} />
													Expert-backed asset allocation
												</span>
												<span className="text-center text-md-start padding-12px-tb ps-2 ps-sm-3  ps-md-4 e-border-left-1px-bright-gray-2  d-flex flex-column flex-md-row align-items-center gap-12px e-text-black e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-16px ">
													<Icon icon="smar-simple" size={"1.5rem"} />
													Smarter and simpler investments
												</span>
											</div>
											<div className="text-center text-md-start d-flex flex-column flex-md-row  align-items-center flex-wrap gap-2 e-text-dark-jet e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px">
												Trusted by <span className="e-font-weight-500"> 1,40,89,501 </span> folios of investors like you
												<span className="e-bg-cultured d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill">
													<Icon icon="arn-shild" size={"1rem"} />
													<span className="e-text-charleston-green e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-16px">
														ARN-272159
													</span>
												</span>
												<p className="e-font-weight-500 mb-0">
													AMFI & SEBI registered firm
												</p>
											</div>
										</div>
									</div>
								</section>

								<section className="mt-5 padding-32px-lr padding-0px-lr-res">
									<h6 className="text-center e-text-chinese-black e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px mb-3">
										Indian Index Fund Industry Facts
									</h6>
									<div className="row row-gap-4 gx-5 justify-content-center">
										<div className="col-sm-11 col-md-10 col-lg-6">
											<div className="e-bg-ghost-white-2 e-border-radius-24 padding-40px-all e-padding-24px-res-all-lg padding-16px-all-res text-center   h-100">
												<img
													src={require("../../../Assets/Images/Onboarding/invest/capital-growth.png")}
													alt="capital-growth"
													className="img-fluid mb-5 col-9 col-sm-7 col-lg-8"
													draggable="false"
												/>
												<p className="e-text-dark-jet e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px mb-0">
													Our customers invest
													<span className="e-font-weight-500 px-1">
														exclusively in low-cost index funds
													</span>
													and the results speak for themselves.  By
													<span className="e-font-weight-500 px-1">
														avoiding costly active funds,
													</span>
													they consistently outperform 98% of mutual fund investors and so-called “expert” fund managers.
												</p>
											</div>
										</div>
										<div className="col-sm-11 col-md-10 col-lg-6">
											<div className="e-bg-ghost-white-2 e-border-radius-24 padding-40px-tb e-padding-24px-res-tb-lg padding-16px-tb-res  text-center h-100">
												<h6 className=" e-text-dark-jet  e-font-14 e-alt-font-poppins e-font-weight-500 line-height-14px mb-0">
													Asset Wise Breakdown
												</h6>
												<div className="table-wrapper  w-max-content mx-auto mt-4" >
													<div className="table-header d-flex ">
														<div className="header-1">
															<span>Asset Class</span>
														</div>
														<div className="header-2">
															<span>Total Allocation</span>
														</div>
													</div>
													<div className="table-body">
														<table className="custom-table mb-0">
															<tbody>
																<tr>
																	<td>Equity</td>
																	<td>₹2.1 Lakh Crore</td>
																</tr>
																<tr>
																	<td>Bonds</td>
																	<td>₹1.01 Lakh Crore</td>
																</tr>
																<tr>
																	<td>Gold & Silver (ETF)</td>
																	<td>₹1.4 Lakh Crore</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div className="table-footer d-flex">
														<div className="header-1">
															<span></span>
														</div>
														<div className="header-2">
															<span></span>
														</div>
													</div>
													<span className="d-block text-end padding-2-top pe-1 e-text-egyptian-blue e-font-8 e-alt-font-poppins e-font-weight-400 line-height-20px mb-0">
														*Vertical Scroll
													</span>
												</div>

												<p className="e-text-dark-jet e-font-12-res e-font-14 padding-40px-lr e-padding-24px-res-lr-lg  e-padding-16px-lr-res e-alt-font-poppins e-font-weight-400 line-height-20px mb-0">
													As of October 2025, India’s Index Fund & ETF industry has
													<span className="e-font-weight-500 px-1">
														crossed ₹3.2 lakh crore in Assets Under Management
													</span>
													a strong sign of how quickly investors are shifting to transparent, rules-based, market-linked investing.
												</p>
											</div>
										</div>
									</div>
								</section>
								{
									sliderVideos.length !== 0 ?
										<section className="mt-4 mt-sm-5">
											<h6 className="text-center e-text-chinese-black e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px mb-3">
												Hear from our Team
											</h6>
											<div className="d-flex gap-lg-4 flex-nowrap margin-0px-left-res margin-32px-left padding-32px-right e-padding-0px-left-res e-border-radius-16 overflow-scroll no-scrollbar ">
												{sliderVideos.map((item, index) => (
													<div id="onboarding-invest-video-card" className={`col-10 col-sm-6 ${props.index !== 5 ? "pe-3 pe-md-4" : ""}`}>
														<VideoCard key={index} data={item} index={index} />
													</div>
												))}
											</div>
										</section>
										:
										null

								}


								<section className="mt-4 mt-sm-5 padding-32px-lr padding-0px-lr-res">
									<h6 className="text-center e-text-chinese-black e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px mb-3">
										Frequently asked question
									</h6>
									<div className="accordion accordion-flush" id="accordion-invest">
										<div className="accordion-item mb-3">
											<h2 className="accordion-header">
												<button
													className={`e-font-12-res accordion-button bg-transparent shadow-none p-0 pb-2 e-text-dark-jet e-alt-font-poppins e-font-14 e-font-weight-500 line-height-20px`}
													type="button"
													data-bs-toggle="collapse"
													data-bs-target={`#item1`}>
													1.What's the minimum investment?
												</button>
											</h2>
											<div id="item1"
												className={`accordion-collapse collapse show`}
												data-bs-parent="#accordion-invest">
												<div className="accordion-body p-0 pb-3">
													<p className="line-height-22px-res mb-0 e-text-dark-jet e-alt-font-poppins e-font-12 e-font-weight-400 line-height-20px">
														We don't set the minimums—the investment funds do. But here's the good news: many popular funds let you start your journey for as little as
														<span className="px-1 e-font-weight-500">₹500!</span>
														Getting started is easier and more accessible than you think.
													</p>
												</div>
											</div>
										</div>
										<div className="accordion-item mb-3">
											<h2 className="accordion-header">
												<button
													className={`e-font-12-res collapsed accordion-button bg-transparent shadow-none p-0 pb-2 e-text-dark-jet e-alt-font-poppins e-font-14 e-font-weight-500 line-height-20px`}
													type="button"
													data-bs-toggle="collapse"
													data-bs-target={`#item2`}
												>
													2.How do I ensure my money is safe?
												</button>
											</h2>
											<div id="item2"
												className={`accordion-collapse collapse`}
												data-bs-parent="#accordion-invest">
												<div className="accordion-body p-0 pb-3 line-height-22px-res mb-0 e-text-dark-jet e-alt-font-poppins e-font-12 e-font-weight-400 line-height-20px">
													<p className="mb-2">
														Your security is our<span className="px-1 e-font-weight-500">top priority.</span>
													</p>
													<ul>
														<li>
															<span className="e-font-weight-500 pe-1">Regulated and Licensed:</span>
															We are fully regulated by<span className="e-font-weight-500 px-1">SEBI</span>(Securities and Exchange Board of India)
															and licensed under<span className="e-font-weight-500 px-1">AMFI</span>(Association of Mutual Funds in India). This means we operate under the strictest government oversight.
														</li>
														<li>
															<span className="e-font-weight-500 pe-1">Direct Investment:</span>
															The money you invest is<span className="e-font-weight-500 px-1">never</span>held by us.
															It goes<span className="e-font-weight-500 px-1">directly</span>to the Asset Management Company (AMC) you choose.
															We act purely as a secure platform, ensuring<span className="e-font-weight-500 px-1">complete safety</span>for your capital.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</section>

								<div className="e-bg-white padding-20px-tb padding-32px-lr position-sticky z-index-99 bottom-0 start-0">
									<div className="col-sm-6 col-lg-4 ms-auto">
										<PrimaryButton
											name="Start Investing"
											className={`w-100 padding-14px-tb e-font-14 padding-8px-tb-res`}
											onPress={_handleNavigateFundListing}
										/>
									</div>
								</div>
							</div>
						) : currentStep === 2 ? (
							<div className="padding-32px-all d-flex flex-column	min-vh-100	padding-0px-all-res">
								<div className="d-flex justify-content-between align-items-center margin-40px-bottom margin-24px-bottom-res">
									<Icon
										icon="arrow-back-left"
										className="cursor-pointer w-24 width-20px-res"
										onClick={_handleBack} />
									<button className="border-0 bg-transparent no-outline e-text-egyptian-blue e-font-12-res e-font-16 e-alt-font-poppins e-font-weight-500  mb-0" onClick={_handleShowWhyMandatoryInvestModal}>
										Why Mandatory invest?
									</button>
								</div>

								<div className="d-flex justify-content-center align-items-center flex-column gap-3 margin-40px-bottom margin-24px-bottom-res">
									<div className="d-flex align-items-center gap-2">
										<img
											src={require("../../../Assets/Images/Onboarding/invest/gold-feather.svg").default}
											width={8}
											height={14}
											alt="gold  feather"
											draggable="false" />
										<h1 className="e-text-chinese-black e-font-16-res e-font-20 e-alt-font-poppins e-font-weight-600  mb-0">
											Top picks for you
										</h1>
										<img
											src={require("../../../Assets/Images/Onboarding/invest/gold-feather.svg").default}
											width={8}
											height={14}
											alt="gold  feather"
											className="flip-image"
											draggable="false" />
									</div>
									<p className="text-center e-text-dark-jet e-font-12-res  e-font-14 e-alt-font-poppins e-font-weight-400  mb-0">
										Index funds are already trusted with<span className="e-font-weight-500 px-1">₹3.2 lakh crore in India</span>
										<br />
										Your <span className="e-font-weight-500 px-1">personalised portfolio</span> follows the same disciplined, low-cost approach.
									</p>
								</div>


								<div className="d-flex gap-2 gap-sm-3 mb-3 justify-content-center">
									{categories.map((type, i) => (
										<span key={i}
											className={`${selectedFundType?.id == type.id
												? "e-bg-egyptian-blue  e-text-white"
												: "e-bg-alice-blue_2 e-text-raisin-black"
												}  cursor-pointer d-flex align-items-center justify-content-center px-2 px-sm-3 py-1 py-sm-2 e-border-radius-32 e-font-12-res  e-font-16 e-alt-font-poppins e-font-weight-500`}
											onClick={() => _handleSelectFundType(type)}>
											{type.name}
										</span>
									))}
								</div>

								<div className="mb-4">
									{
										loading ?
											<div className="min-h-100vh text-center mt-sm-5 pt-5" >
												<img src={Loader}
													className='object-fit-contain w-20 width-24px-res'
													draggable="false"
													alt="loader" />
											</div>
											:
											<>
												{
													fundList.length ?
														<div className="row row-gap-3 row-gap-sm-4">
															{
																fundList.map((item, key) => {
																	return (
																		<div className="col-12 col-md-6" key={key}>
																			<FundCard type={2}
																				data={item}
																				handleInvest={_handleShowInvestModal} />
																		</div>
																	)
																})
															}

															{/* Pagination  */}
															<div className="row mt-4 mx-auto">
																{
																	fundList.length > 0 &&
																	<div className="e-display-flex e-gap-0-16 justify-content-center">
																		<Pagination nextButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
																			prevButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
																			itemsPerPage={ITEMS_PER_PAGE}
																			totalPage={totalPageCount}
																			initialPage={currentPage - 1}
																			onChange={_handlePagination}
																			showFirstLastPages={true} />
																	</div>
																}
															</div>

														</div>
														:
														<EmptyScreen
															img={EmptyFunds}
															title="No funds found !"
															description="There is nothing to show right now." />
												}
											</>
									}
								</div>

								{/* Explore more funds */}
								<div className="d-flex flex-column flex-sm-row justify-content-sm-between row-gap-3 align-items-center e-bg-lavender-web e-border-radius-32 e-border-radius-16-res p-3 mt-auto mb-4 mb-sm-0">
									<h6 className="d-flex align-items-center gap-3 e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400  mb-0">
										<img
											src={require("../../../Assets/Images/Onboarding/invest/explore-funds.svg").default}
											alt="Explore more funds"
											width={24}
											height={24}
											draggable="false"
										/>
										Explore our full range of funds and find more expert-backed investment opportunities.
									</h6>

									<PrimaryButton
										name="Explore More Funds"
										className={`py-2 px-3 e-font-14-res  e-font-16 e-border-radius-32 col-auto`}
										onPress={_handleNavigateExplore}
									/>
								</div>

							</div>
						) : (
							<div className="padding-32px-all padding-0px-all-res">
								<div className=" d-flex gap-4">
									<Icon
										icon="arrow-back-left"
										className="cursor-pointer"
										size={24}
										onClick={_handleBack} />
									<h6 className="e-text-chinese-black e-font-16-res e-font-20 e-alt-font-poppins e-font-weight-600 line-height-24px mb-0">
										Explore Mutual Funds
									</h6>
								</div>
								<div className="mt-4 pt-sm-3">
									<div className="position-relative ">
										<CustomTextInput id="explore-search"
											className="w-100 no-outline padding-10px-tb padding-56px-lr padding-32px-lr-res"
											placeholder="Search with fund name"
											inputWrapperClassName={"e-border-1px-sonic-silver"}
											inputWrapperBorderStyle={"e-border-radius-10"}
											autoComplete="off"
											value={searchValue}
											handleChange={_handleSearchChange} />
										<img src={require("../../../Assets/Images/search-icon.svg").default}
											draggable={false}
											className="width-20px-res position-absolute top-50 translate-middle-y start-0 ms-2 ms-sm-3"
											alt="search" />
										{
											searchValue &&
											<>
												{/* Enter search btn */}
												<div className="e-searchSwitch" onClick={_handleSearchFund}>
													<Icon
														icon="arrow-back-left"
														className="cursor-pointer"
														fill="#fff"
														size={24} />
												</div>
												{/* Close btn */}
												<img src={require("../../../Assets/Images/close-btn.svg").default}
													draggable={false}
													className="width-24px-res object-fit-contain position-absolute top-50 translate-middle-y right-70px me-2 me-sm-3 cursor-pointer"
													alt="clear"
													onClick={() => _handleSearchChange("")} />
											</>
										}
									</div>
								</div>
								{
									loading ?
										<div className="min-h-100vh text-center mt-5 pt-5" >
											<img src={Loader}
												className='object-fit-contain w-20 width-24px-res'
												draggable="false"
												alt="loader" />
										</div>
										:
										<div className="pt-sm-3">
											{
												fundList.length ?
													<div className="row row-gap-3 row-gap-sm-4">
														{
															fundList.map((item, key) => {
																return (
																	<div className="col-12 col-md-6" key={key}>
																		<FundCard type={2}
																			data={item}
																			handleInvest={_handleShowInvestModal} />
																	</div>
																)
															})
														}
														{/* Pagination  */}
														<div className="row mt-4 mb-4 mb-sm-0 mx-auto">
															{
																fundList.length > 0 &&
																<div className="e-display-flex e-gap-0-16 justify-content-center">
																	<Pagination nextButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
																		prevButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
																		itemsPerPage={ITEMS_PER_PAGE}
																		totalPage={totalPageCount}
																		initialPage={currentPage - 1}
																		onChange={_handlePagination}
																		showFirstLastPages={true} />
																</div>
															}
														</div>

													</div>
													:
													<EmptyScreen
														img={EmptyFunds}
														title="No funds found !"
														description="There is nothing to show right now." />
											}
										</div>
								}

							</div>
						)}
				</div>
			</div>

			{
				showInvestModal && (
					<OnboardingInvestModal
						fundSummary={fundSummary}
						availableInvestmentTypes={{ sip: true, lumpsum: true }}
						investmentType={1} // SIP
						onboardingFlow={true}
						fundData={fundData}
						onCloseModal={_handleCloseInvestModal}
					/>
				)
			}

			{
				showWhyInvestModal &&
				<WhyMandatoryInvestModal onClose={_handleCloseWhyMandatoryInvestModal} />
			}
			{
				currentVideo !== null ?
					<OnboardingVideoModal data={currentVideo}
						onClose={() => setCurrentVideo(null)} />
					:
					null
			}
		</div >

	);
}

export default BasketList;

